import { type MessageDTO, type PreviewItemDTO } from "./dtos";
import { type MessageModel, type PreviewItem } from "./models";
import { getNextUID } from "../utils/uid";

export function transformPreviewItem(dto: PreviewItemDTO): PreviewItem {
  return {
    onSale: !!dto.onSale,
    id: getNextUID(),
    quantity: dto.quantity,
    productId: dto.productId,
    requestedDeliveryDate: dto.requestDeliveryDate ? new Date(dto.requestDeliveryDate) : undefined,
    messages: dto.messages.map(transformMessage),
    comment: dto.comment,
    isCommentVisible: false,
    priceReference: dto.priceReference || "",
    quantityVisible: dto.quantityVisible ?? true,
    marketType: dto.type,
    succeedingProductUrl: dto.succeedingProductUrl,
    succeedingProductDesignation: dto.succeedingProductDesignation,
    customerOrderNumber: dto.customerOrderNumber
  };
}

function transformMessage(dto: MessageDTO): MessageModel {
  return {
    type: dto.type === "INFO" ? "info" : "error",
    code: dto.code,
    params: dto.additionalParams,
  };
}
